// gimme: conversations-inbox-ui 06/10/2020 24a2e66917cc934433dd111db7e06fd02943ca6a
import pluck from 'transmute/pluck';
import { getUnpublishedMessages } from './getUnpublishedMessages';
import { getUnpublishedMessagesMatchingThreadId } from '../operators/getUnpublishedMessagesMatchingThreadId';
import { threadIdFromProps } from '../../_internal/selectors/threadIdFromProps';
import { createSelector } from 'reselect';
export const getUnpublishedMessagesForThreadId = createSelector([getUnpublishedMessages, threadIdFromProps], (unpublishedMessages, threadId) => {
  const pluckDataFromMap = pluck('data');
  return pluckDataFromMap(getUnpublishedMessagesMatchingThreadId(threadId, unpublishedMessages));
});